import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { DatePipe } from '@angular/common';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NoPreloading, RouterModule, Routes } from '@angular/router';
import { ServiceWorkerModule } from '@angular/service-worker';
import { UserIdleModule } from 'angular-user-idle';
import { AddToHomeScreenComponent } from './add-to-home-screen/add-to-home-screen.component';
import { AuthGuard } from './app-guard';
import { AppComponent } from './app.component';
import { MyHttpLogInterceptor } from './http.interceptor';
import { LoadingInterceptor } from './loader.intercepter';
import { LoginComponent } from './login/login.component';
import { LoginModule } from './login/login.module';
import { SharedModule } from './modules/shared.module';
import { NotSupportedComponent } from './not-supported/not-supported.component';
import { PermissionDeniedComponent } from './permission-denied/permission-denied.component';
import { SharedService } from './services/shared.service';
import { SnackbarComponent } from './snackbar/snackbar.component';

const routes: Routes = [
  { path: '', redirectTo: '/login', pathMatch: 'full' },
  { path: 'login', component: LoginComponent },
  { path: 'not-supported', component: NotSupportedComponent },
  { path: 'permission-denied', component: PermissionDeniedComponent },
  {
    path: 'resetPassword',
    loadChildren: () => import('./resetpassword/resetpassword.module').then(m => m.ResetPasswordModule),
  },
  { path: 'portal', loadChildren: () => import('./modules/home.module').then(m => m.HomeModule), canActivate: [AuthGuard] },
];

@NgModule({
  declarations: [AppComponent, SnackbarComponent, AddToHomeScreenComponent, PermissionDeniedComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    SharedModule,
    LoginModule,
    MatSnackBarModule,
    // Optionally you can set time for `idle`, `timeout` and `ping` in seconds.
    // Default values: `idle` is 600 (10 minutes), `timeout` is 300 (5 minutes)
    // and `ping` is 120 (2 minutes).
    UserIdleModule.forRoot({ idle: 3300, timeout: 300, ping: 1080 }),
    RouterModule.forRoot(routes, { useHash: true, enableTracing: false, preloadingStrategy: NoPreloading }),
    ServiceWorkerModule.register('/ngsw-worker.js', { enabled: true }),
  ],
  exports: [],
  entryComponents: [SnackbarComponent, AddToHomeScreenComponent],
  providers: [{ provide: HTTP_INTERCEPTORS, useClass: MyHttpLogInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: LoadingInterceptor, multi: true }, SharedService, DatePipe],
  bootstrap: [AppComponent],
})
export class AppModule {}
